/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import classes from "../SharedComponents/DeleteDialog.module.css";
export interface SuccessDialogProps {
  handleClose(): void;
  SucessConfirmationMessage: string;
  open: boolean;
  title: string;
}

const SuccessDialog = (props: SuccessDialogProps) => {
  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <DialogTitle
        sx={{
          backgroundColor: "#272727",
          width: "400px",
          height: "100px",
        }}
        className={classes.dialogHeading}
        id="dialog-title"
      >
        {props.title}
        <IconButton
          edge="end"
          color="inherit"
          onClick={props.handleClose}
          aria-label="close"
          sx={{ marginLeft: "auto" }}
        >
          <CloseIcon onClick={props.handleClose} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: "#272727" }}>
        <DialogContentText
          sx={{ backgroundColor: "#272727" }}
          className={classes.dialogInfo}
        >
          {props.SucessConfirmationMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          backgroundColor: "#272727",
          paddingRight: 4,
          paddingBottom: 4,
        }}
      >
        <Button className={classes.createButton} onClick={props.handleClose}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};
/// end return Dialog

export default SuccessDialog;
